export enum AgeRate {
  // These 4 will be useD in PROD
  FAMILY = 'FAMILY',
  PG = 'PG',
  Fifteen = '15',
  Eighteen = '18',
  // TODO - remove belows later on
  PG15 = 'PG15',
  Sixteen = '16',
  SixteenD = '16D',
  EighteenR = '18R',
  R = 'R',
}
